<div mat-dialog-title *ngIf="data.title">
	<h2>
		{{data.title}}
	</h2>
</div>
<div mat-dialog-content>
	<form [formGroup]="form" (submit)="handleSubmit(form.value)">
		<cm-multiselect [options]="data.options" formControlName="selected"></cm-multiselect>
		<button type="submit" class="cdk-visually-hidden">
			<span [cmLocalize]="portalCoreFeature + '/System.MultiselectModal.Button.Select'">
				Select
			</span>
		</button>
	</form>
</div>
<div mat-dialog-actions>
	<button mat-dialog-close>
		<span [cmLocalize]="portalCoreFeature + '/System.MultiselectModal.Button.Cancel'">
			Cancel
		</span>
	</button>
	<button [mat-dialog-close]="form.value" color="primary">
		<span [cmLocalize]="portalCoreFeature + '/System.MultiselectModal.Button.Select'">
			Select
		</span>
	</button>
</div>
